import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Select, FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import GridContainer from '../GridContainer';
import DateFnsUtils from '@date-io/date-fns';
import '../CommonFilter/filter.scss';

const SafetyReportFilter = ({
  users,
  safetyProjects,
  onFilter,
  initialFormState,
  showProjectFields
}) => {
  const formRef = useRef();

  return (
    <Formik
      innerRef={formRef}
      initialValues={{ ...initialFormState }}
      validationSchema={Yup.object({
        fromDate: Yup.date().required(),
        toDate: Yup.date().required()
      })}
      enableReinitialize
      onSubmit={(values) => onFilter(values)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <GridContainer className="commonFilter">
            <div>
              <FormControl fullWidth variant="outlined">
                <InputLabel>User</InputLabel>
                <Select
                  value={values.userId}
                  label="User"
                  onChange={({ target: { value } }) => setFieldValue('userId', value)}
                >
                  <MenuItem value="">
                    <em>All</em>
                  </MenuItem>
                  {users
                    .filter(({ role }) => role === 2)
                    .map((user) => (
                      <MenuItem value={user.id} key={user.id}>
                        {`${user.firstname} ${user.lastname}`}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
            {showProjectFields && (
              <div>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>Safety Project</InputLabel>
                  <Select
                    value={values.safetyProjectId}
                    label="Safety Project"
                    onChange={({ target: { value } }) => setFieldValue('safetyProjectId', value)}
                  >
                    <MenuItem value="">
                      <em>All</em>
                    </MenuItem>
                    {safetyProjects.map((p) => (
                      <MenuItem value={p.id} key={p.id}>
                        {p.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            )}
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  label="From Date"
                  inputVariant="outlined"
                  value={values.fromDate}
                  onChange={(e) => setFieldValue('fromDate', e)}
                  style={{ width: '100%' }}
                  format="MMM-dd-yyyy"
                  maxDate={values.toDate}
                  showTodayButton
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  label="To Date"
                  inputVariant="outlined"
                  value={values.toDate}
                  onChange={(e) => setFieldValue('toDate', e)}
                  style={{ width: '100%' }}
                  format="MMM-dd-yyyy"
                  minDate={values.fromDate}
                  showTodayButton
                  autoOk
                />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <Button onClick={() => formRef.current.submitForm()} color="primary" variant="contained">
                Filter
              </Button>
            </div>
          </GridContainer>
        </Form>
      )}
    </Formik>
  );
};

SafetyReportFilter.propTypes = {
  users: PropTypes.array,
  safetyProjects: PropTypes.array,
  onFilter: PropTypes.func,
  initialFormState: PropTypes.object,
  showProjectFields: PropTypes.bool
};

export default SafetyReportFilter;
